/// 検索周り
const toggleClassName = 'checked';

const clickHandler = () => {
    const labels = document.querySelectorAll('.s-search-items label');
    
    for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const checkbox = label.getElementsByTagName('input')[0];

        if (!checkbox) continue;
        
        checkbox.addEventListener('change', (event) => {
            const crt = event.currentTarget;
            sameLabelsRemove(labels, crt);
            toggleClass(crt, label);
        });

        toggleClass(checkbox, label); /// 読み込み時
    }
};

const sameLabelsRemove = (labels, crt) => {
    for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const radio = label.getElementsByTagName('input')[0];
        if (!radio) continue;
        if (radio.getAttribute('name') !== crt.getAttribute('name')) continue;
        
        label.classList.remove(toggleClassName);
    }
}

const toggleClass = (checkbox, label) => {
    if (checkbox.checked) label.classList.add(toggleClassName);
    else label.classList.remove(toggleClassName);
}

window.addEventListener('DOMContentLoaded', clickHandler, false);


// WEBPACK FOOTER //
// ./js/modules/search.js